module.exports = __webpack_public_path__ + "static/media/mycawan.ebdde485.svg";